import React, { useState, useEffect, useMemo } from 'react'
import { Navigate } from 'react-router-dom'
import axios from 'axios'
import ProductLayout from './ProductLayout'

const API = ''

/**
 * Products landing page - redirects to the first category if categories exist,
 * otherwise shows a loading state.
 */
const ProductsLandingPage = () => {
    const [categories, setCategories] = useState([])
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        axios.get(`${API}/api/categories`).then(r => {
            setCategories(r.data)
            setLoaded(true)
        }).catch(() => setLoaded(true))
    }, [])

    const navCategories = useMemo(() => {
        const cats = [{ id: 'all', name: 'All Products', slug: 'all-products' }]
        categories.forEach(c => {
            cats.push({ ...c, slug: `cat-${c.id}` })
        })
        cats.push({ id: 'custom', name: 'Custom Products', slug: 'custom-products' })
        return cats
    }, [categories])

    if (!loaded) {
        return (
            <ProductLayout>
                <div style={{ padding: '48px 32px', textAlign: 'center', color: 'var(--pfc-text3)' }}>
                    Loading product catalog...
                </div>
            </ProductLayout>
        )
    }

    // Default redirect to All Products page
    if (categories.length > 0) {
        return <Navigate to="/products/category/all" replace />
    }

    return (
        <ProductLayout>
            <div style={{ padding: '48px 32px', textAlign: 'center', color: 'var(--pfc-text3)' }}>
                No product categories found.
            </div>
        </ProductLayout>
    )
}

export default ProductsLandingPage
